import React from 'react';
import styles from './Input.module.scss';

function Input(props) {
    return (
        <input className={styles.formInput} {...props}/>
    );
}

export default Input;